// extracted by mini-css-extract-plugin
module.exports = {"root":"_87b0662","embedded":"_373bdf9","subTitle":"_9822912","buttonContainer":"_4d1a432","heading":"_f519d92","descriptionContainer":"_c4d829b","accessSentance":"_d246cba"};